
	import Vue from "vue";

	export default Vue.extend({
		name: "LinearScaleField",
		props: {
			disabled: {
				type: Boolean,
				default: true,
			},
			min: {
				type: Number,
				default: 0,
			},
			max: {
				type: Number,
				default: 0,
			},
			fromLabel: {
				type: String,
				default: "",
			},
			toLabel: {
				type: String,
				default: "",
			},
      required: {
        type: Boolean,
        default: false,
      },
      extraValidations: {
        type: Boolean,
        default: false,
      },
      validation: {
        type: String,
        default: ""
      },
			value: {
				type: Number,
				default: null,
			},
		},
		data() {
			return {
				sliderValue: this.value,
			};
		},
		methods: {},
		watch: {
      value: function (value) {
        this.sliderValue = value;
      },
			sliderValue: function (value) {
				this.sliderValue = value;
				this.$emit("input", value);
			},
		},
	});
